import { useEffect, useState } from "react";

export const useGeoLocation = () => {
  const [isGeoLocationAvailable, setIsGeoLocationAvailable] = useState(false);

  const options = {
    timeout: 5000,
    maximumAge: 0,
  };

  useEffect(() => {
    if (!("geolocation" in navigator)) {
      return;
    }

    if (!("permissions" in navigator)) {
      // just allow geolocation anyway if Permissions aren't available because we're trying to call Geolocation down the road either way.
      // Some browsers do not have the Permissions API, but the Geolocation API exists either way.
      setIsGeoLocationAvailable(true);
      return;
    }

    navigator.permissions
      .query({ name: "geolocation" })
      .then((result) => {
        setIsGeoLocationAvailable(result.state === "granted" || result.state === "prompt");
        result.onchange = () => {
          setIsGeoLocationAvailable(result.state === "granted");
        };
      })
      .catch(() => {
        setIsGeoLocationAvailable(true);
      });
  }, []);

  const getGeoLocation = (): Promise<GeolocationPosition> => {
    return new Promise((resolve, reject) => {
      if (typeof window === "undefined" || !("geolocation" in navigator)) {
        reject(new Error("Geolocation is not supported by this environment"));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => resolve(position),
        (error) => {
          // TIMEOUT → silently ignore (do not report to Sentry)
          if (error.code === 3) return;
          reject(error);
        },
        options,
      );
    });
  };

  return {
    isGeoLocationAvailable,
    getGeoLocation,
  };
};
